<div class="container-fluid">
  <app-pagetitle title="Architectes"></app-pagetitle>

  <div class="row">

    <div class="col-lg-12">
      <div class="card">
        <div class="card-body">
          <div class="dropdown float-right pt-2" ngbDropdown>
            <a href="javascript: void(0);" class="dropdown-toggle arrow-none card-drop" ngbDropdownToggle
              data-toggle="dropdown" aria-expanded="false">
              <i class="mdi mdi-dots-vertical"></i>
            </a>
            <div class="dropdown-menu dropdown-menu-right" ngbDropdownMenu>
              <a href="javascript:void(0);" class="dropdown-item">Exporter</a>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 col-md-12">
              <div id="tickets-table_filter" class="dataTables_filter text-md-right"><label
                  class="d-inline-flex align-items-center">Rechercher:
                  <input type="text" name="searchTerm" class="form-control form-control-sm ml-2"
                    aria-controls="tickets-table" [(ngModel)]="term" /></label></div>
            </div>
          </div>
          <div class="table-responsive">
            <!-- <div class="spinner-border text-info m-1" role="status">
              <span class="sr-only">Loading...</span>
            </div> -->
            <table class="table table-centered">
              <thead class="thead-light">
                <tr>
                  <th width="300">Identifiant</th>
                  <th width="300">Nom et Prénom</th>
                  <th width="300">Email</th>
                  <th width="250" *ngIf="user.type == 'admin'">Dernière connection</th>
                  <th width="100" *ngIf="user.type == 'admin'">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let item of designers |filter:term">
                  <td>{{item.code}}</td>
                  <td><a [routerLink]="['/designers/', item.id]">{{item.fullname}}</a></td>
                  <td>{{item.email}}</td>
                  <td *ngIf="user.type == 'admin'">{{item.last_connected_at}}</td>
                  <td *ngIf="user.type == 'admin'">
                    <div (click)="connectAs( item.id )" class="btn btn-sm btn-rounded btn-secondary"> <i
                        class="fas fa-link p-0"></i></div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>
